<script setup>
import { useAcademyStore } from "@/stores";
import { onMounted, ref } from "vue";

const academyStore = useAcademyStore();

const embedUrl = ref(null);

onMounted(async () => {
  embedUrl.value = await academyStore.getAcademyEvaluationsDashboard();
});
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="page-title">Evaluations Dashboard</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <div style="height: 100vh">
          <iframe
            v-if="embedUrl"
            :src="embedUrl"
            frameborder="0"
            allowtransparency="true"
            style="width: 100%; height: 100%"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
h1,
h2 {
  color: rgb(var(--v-theme-academy));
}
.v-table {
  td,
  th {
    border-right: thin solid
      rgba(var(--v-border-color), var(--v-border-opacity));
  }
}
.flex-50 {
  flex: 0 0 60% !important;
}
.flex-25 {
  flex: 0 0 20% !important;
}
</style>
